import {
  CLEAR_TEST_INFO,
  END_TEST_TIMER,
  GET_TEST_BY_COURSE,
  GET_TEST_BY_COURSE_ERROR,
  GET_TEST_BY_COURSE_LOADING,
  GET_TEST_BY_COURSE_SUCCESS,
  GET_TEST_QUESTIONS,
  GET_TEST_QUESTIONS_ERROR,
  GET_TEST_QUESTIONS_LOADING,
  GET_TEST_QUESTIONS_SUCCESS,
  GET_TEST_RESULT,
  GET_TEST_RESULT_CLEAR,
  GET_TEST_RESULT_ERROR,
  GET_TEST_RESULT_LOADING,
  GET_TEST_RESULT_SUCCESS,
  INSERT_TEST_DATA,
  INSERT_TEST_DATA_ERROR,
  INSERT_TEST_DATA_LOADING,
  INSERT_TEST_DATA_SUCCESS,
  QUESTION_SAVE_AND_NEXT,
  QUESTION_SAVE_AND_NEXT_EVAL,
  SET_TEST_INFO,
  SET_TOTAL_QUESTION,
  START_TEST_TIMER,
} from "./constants";

export const getTestByCourse = (payload) => ({
  type: GET_TEST_BY_COURSE,
  payload,
});
export const getTestByCourseLoading = () => ({
  type: GET_TEST_BY_COURSE_LOADING,
});
export const getTestByCourseSuccess = (payload) => ({
  type: GET_TEST_BY_COURSE_SUCCESS,
  payload,
});
export const getTestByCourseError = (payload) => ({
  type: GET_TEST_BY_COURSE_ERROR,
  payload,
});

export const getTestResult = (payload) => ({ type: GET_TEST_RESULT, payload });
export const getTestResultLoading = () => ({ type: GET_TEST_RESULT_LOADING });
export const getTestResultSuccess = (payload) => ({
  type: GET_TEST_RESULT_SUCCESS,
  payload,
});
export const getTestResultError = (payload) => ({
  type: GET_TEST_RESULT_ERROR,
  payload,
});
export const getTestResultClear = () => ({ type: GET_TEST_RESULT_CLEAR });

export const setTestInfo = (payload) => ({ type: SET_TEST_INFO, payload });
export const clearTestInfo = () => ({ type: CLEAR_TEST_INFO });

export const getTestQuestions = (payload) => ({
  type: GET_TEST_QUESTIONS,
  payload,
});
export const getTestQuestionsLoading = () => ({
  type: GET_TEST_QUESTIONS_LOADING,
});
export const getTestQuestionsSuccess = (payload) => ({
  type: GET_TEST_QUESTIONS_SUCCESS,
  payload,
});
export const getTestQuestionsError = (payload) => ({
  type: GET_TEST_QUESTIONS_ERROR,
  payload,
});

export const startTestTimer = (payload) => ({
  type: START_TEST_TIMER,
  payload,
});
export const endTestTimer = (payload) => ({ type: END_TEST_TIMER, payload });

export const setTotalQuestion = (payload) => ({
  type: SET_TOTAL_QUESTION,
  payload,
});
export const questionSaveAndNext = (payload) => ({
  type: QUESTION_SAVE_AND_NEXT,
  payload,
});
export const questionSaveAndNextEval = (payload) => ({
  type: QUESTION_SAVE_AND_NEXT_EVAL,
  payload,
});
export const insertTestData = (payload) => ({
  type: INSERT_TEST_DATA,
  payload,
});
export const insertTestDataLoading = () => ({ type: INSERT_TEST_DATA_LOADING });
export const insertTestDataSuccess = (payload) => ({
  type: INSERT_TEST_DATA_SUCCESS,
  payload,
});
export const insertTestDataError = (payload) => ({
  type: INSERT_TEST_DATA_ERROR,
  payload,
});
